import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import "./navigation.scss";
import { AuthContext } from "../Context/AuthContext";
import { getUserIndustry, hasClient } from "../Utils/utils";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const urlSchema = {
  crm: ["crm", "contact-details", "company-management", "company-details"],
  dashboard: ["dashboard", "edit-dashboard", "new-dashboard"],
  contact: ["crm", "contact-details"],
  owners: ["owners"],
  company: ["company-management", "company-details"],
  sales: [
    "sales/pipeline",
    "sales/subscriptions",
    "sales/agreements",
    "estimates",
    "invoices",
  ],
  scheduling: ["bookings", "my-schedule", "settings/tasks", "appointments"],
  automation: ["automation", "automation/create", "campaign-analytics"],
  marketing: [
    "marketing/landing-pages",
    "marketing/emails",
    "marketing/forms",
    "lead-capture/meta/forms",
    "lead-capture/linkedin/forms",
    "marketing/chatbot",
    "marketing/whatsapp-management",
    "social-media",
    "social-media/add-account",
    "social-media/social-post",
    "social-media/monitoring",
    "marketing/sms-management",
  ],
  engagements: ["engagements"],
  projects: ["projects", "projects-tasks"],
  catalog: [
    "services",
    "subscriptions",
    "ecommerce",
    "subscription",
    "add-plan",
    "add-layout",
  ],
  profile: ["my-profile"],
  settings: ["settings"],
  social: [
    "social-media",
    "social-media/add-account",
    "social-media/social-post",
    "social-media/monitoring",
  ],
};

const Navigation = ({
  companyLogo,
  userImage,
  expanded = false,
  setExpanded = () => {},
}) => {
  const { pathname } = useLocation();
  const { t: locale } = useTranslation(["common", "pages"]);
  const [industry, setIndustry] = useState("");
  const { userData } = useContext(AuthContext);
  const [pathName, setPathName] = useState("");
  // const [expanded, setExpanded] = useState(false);
  /*****/

  useEffect(() => {
    if (pathname) {
      setPathName(pathname.replace("/", ""));
    }
  }, [pathname]);

  useEffect(() => {
    if (userData?.authData) {
      const userIndustry = getUserIndustry(userData);
      if (userIndustry) {
        setIndustry(userIndustry);
        document.title = userData?.authData?.company || "Saleoid";
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const updateBodyClass = () => {
    if (document.body.classList.contains("modal-open")) {
      document.body.classList.remove("modal-open");
    } else {
      document.body.classList.add("modal-open");
    }
  };

  const navigationDrawerHide = () => {
    if (document.body.clientWidth <= 991) {
      setExpanded(expanded ? false : "expanded");
      updateBodyClass();
    }
  };

  /**
   * Show Navigation Menu Items
   **/
  const showMenuItems = (name) => {
    return true;
  };

  /*******/
  return (
    <React.Fragment>
      <Navbar
        bg="white"
        variant="light"
        expand="lg"
        expanded={expanded}
        className={
          hasClient(userData)
            ? "justify-content-between position-sticky top-0"
            : "position-sticky top-0"
        }
        style={{ zIndex: 998 }}
      >
        <Navbar.Collapse id="basic-navbar-nav" className={"primary-navbar"}>
          <Nav className="">
            <Link
              to="/dashboard"
              state={{ industry: industry }}
              className={`nav-link ${
                urlSchema["dashboard"].includes(pathName) ? "active" : ""
              }`}
              role="button"
              // onClick={() => navigationDrawerHide()}
            >
              {locale("pages:navigation.Dashboard")}
            </Link>
            {!hasClient(userData) && (
              <React.Fragment>
                {showMenuItems("crm") && (
                  <NavDropdown
                    title={locale("pages:navigation.CRM")}
                    renderMenuOnMount={true}
                    className={
                      urlSchema["crm"].includes(pathName) ? "active" : ""
                    }
                  >
                    <Link
                      to="/crm"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        urlSchema["contact"].includes(pathName) ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Contacts")}
                    </Link>
                    {showMenuItems("companies") && (
                      <Link
                        to="/company-management"
                        state={{ industry: industry }}
                        className={`dropdown-item ${
                          urlSchema["company"].includes(pathName)
                            ? "active"
                            : ""
                        }`}
                        role="button"
                        onClick={() => navigationDrawerHide()}
                      >
                        {locale("pages:navigation.Companies")}
                      </Link>
                    )}
                  </NavDropdown>
                )}

                {showMenuItems("pipelines") && (
                  <NavDropdown
                    title={locale("pages:navigation.Sales")}
                    renderMenuOnMount={true}
                    className={
                      urlSchema["sales"].includes(pathName) ? "active" : ""
                    }
                  >
                    <Link
                      to="/sales/pipeline"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        pathName === "sales/pipeline" ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Sales Pipeline")}
                    </Link>
                    <Link
                      to="/sales/subscriptions"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        pathName === "sales/subscriptions" ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Subscriptions")}
                    </Link>
                    <Link
                      to="/sales/agreements"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        pathName === "sales/agreements" ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Agreements")}
                    </Link>
                    <Link
                      to="/estimates"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "estimates" === pathName ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Estimates")}
                    </Link>
                    <Link
                      to="/invoices"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "invoices" === pathName ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Invoices")}
                    </Link>
                  </NavDropdown>
                )}

                <NavDropdown
                  title="Scheduling"
                  renderMenuOnMount={true}
                  className={
                    urlSchema["scheduling"].includes(pathName) ? "active" : ""
                  }
                >
                  <Link
                    to="/my-schedule"
                    state={{ industry: industry }}
                    className={`dropdown-item ${
                      "my-schedule" === pathName ? "active" : ""
                    }`}
                    role="button"
                    onClick={() => navigationDrawerHide()}
                  >
                    {locale("pages:navigation.My Schedule")}
                  </Link>

                  <Link
                    to="/bookings"
                    state={{ industry: industry }}
                    className={`dropdown-item ${
                      "bookings" === pathName ? "active" : ""
                    }`}
                    role="button"
                    onClick={() => navigationDrawerHide()}
                  >
                    {locale("pages:navigation.Bookings")}
                  </Link>
                  <Link
                    to="/appointments"
                    state={{ industry: industry }}
                    className={`dropdown-item ${
                      "appointments" === pathName ? "active" : ""
                    }`}
                    role="button"
                    onClick={() => navigationDrawerHide()}
                  >
                    {locale("pages:navigation.Appointments")}
                  </Link>
                  <Link
                    to="/settings/tasks"
                    state={{ industry: industry }}
                    className={`dropdown-item ${
                      "settings/tasks" === pathName ? "active" : ""
                    }`}
                    role="button"
                    onClick={() => navigationDrawerHide()}
                  >
                    Tasks
                  </Link>
                </NavDropdown>

                {showMenuItems("engagements") && (
                  <Link
                    to="/engagements"
                    state={{ industry: industry }}
                    className={`nav-link ${
                      urlSchema["engagements"].includes(pathName)
                        ? "active"
                        : ""
                    }`}
                    role="button"
                    onClick={() => navigationDrawerHide()}
                  >
                    {locale("pages:navigation.engagements")}
                  </Link>
                )}

                {showMenuItems("projects") && (
                  <NavDropdown
                    title="Projects"
                    renderMenuOnMount={true}
                    className={
                      urlSchema["projects"].includes(pathName) ? "active" : ""
                    }
                  >
                    <Link
                      to="/projects"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "projects" === pathName ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Projects")}
                    </Link>
                    <Link
                      to="/projects-tasks"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "projects-tasks" === pathName ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Projects Tasks")}
                    </Link>{" "}
                  </NavDropdown>
                )}

                <Link
                  to="/services"
                  state={{ industry: industry }}
                  role="button"
                  className={`nav-link ${
                    urlSchema["catalog"].includes(pathName) ? "active" : ""
                  }`}
                  onClick={() => navigationDrawerHide()}
                >
                  {locale("pages:navigation.Catalog")}
                </Link>

                <Link
                  to="/automation"
                  state={{ industry: industry }}
                  className={`nav-link ${
                    urlSchema["automation"].includes(pathName) ? "active" : ""
                  }`}
                  role="button"
                  onClick={() => navigationDrawerHide()}
                >
                  {locale("pages:navigation.Automation")}
                </Link>

                {showMenuItems("campaigns") && (
                  <NavDropdown
                    title={locale("pages:navigation.Marketing")}
                    renderMenuOnMount={true}
                    className={
                      urlSchema["marketing"].includes(pathName) ? "active" : ""
                    }
                  >
                    <Link
                      to="/marketing/emails"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "marketing/emails" === pathName ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Emails")}
                    </Link>{" "}
                    <Link
                      to="/marketing/landing-pages"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "marketing/landing-pages" === pathName ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Landing Pages")}
                    </Link>{" "}
                    <Link
                      to="/marketing/forms"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "marketing/forms" === pathName ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Forms")}
                    </Link>
                    <Link
                      to="/lead-capture/meta/forms"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        pathName.includes("lead-capture/meta/forms")
                          ? "active"
                          : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      Meta Lead Forms
                    </Link>
                    <Link
                      to="/lead-capture/linkedin/forms"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        pathName.includes("lead-capture/linkedin/forms")
                          ? "active"
                          : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      LinkedIn Lead Forms
                    </Link>
                    <Link
                      to="/marketing/chatbot"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "marketing/chatbot" === pathName ? "active" : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Chatbot")}
                    </Link>{" "}
                    <Link
                      to="/marketing/whatsapp-management"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "marketing/whatsapp-management" === pathName
                          ? "active"
                          : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.Whatsapp Management")}
                    </Link>{" "}
                    <Link
                      to="/marketing/sms-management"
                      state={{ industry: industry }}
                      className={`dropdown-item ${
                        "marketing/sms-management" === pathName
                          ? "active"
                          : ""
                      }`}
                      role="button"
                      onClick={() => navigationDrawerHide()}
                    >
                      {locale("pages:navigation.SMS Management")}
                    </Link>{" "}
                    {showMenuItems("social_media") && (
                      <NavDropdown
                        title={locale("pages:navigation.Social Media")}
                        id="submenu-nav-dropdown"
                        renderMenuOnMount={true}
                        className={
                          urlSchema["social"].includes(pathName) ? "active" : ""
                        }
                      >
                        <Link
                          to="/social-media/add-account"
                          state={{ industry: industry }}
                          className={`dropdown-item ${
                            ["social-media/add-account"].includes(pathName)
                              ? "active"
                              : ""
                          }`}
                          role="button"
                          onClick={() => navigationDrawerHide()}
                        >
                          {locale("pages:navigation.Add Account")}
                        </Link>
                        <Link
                          to="/social-media/social-post"
                          state={{ industry: industry }}
                          className={`dropdown-item ${
                            ["social-media/social-post"].includes(pathName)
                              ? "active"
                              : ""
                          }`}
                          role="button"
                          onClick={() => navigationDrawerHide()}
                        >
                          {locale("pages:navigation.Schedule Posts")}
                        </Link>
                        <Link
                          to="/social-media/monitoring"
                          state={{ industry: industry }}
                          className={`dropdown-item ${
                            ["social-media/monitoring"].includes(pathName)
                              ? "active"
                              : ""
                          }`}
                          role="button"
                          onClick={() => navigationDrawerHide()}
                        >
                          {locale("pages:navigation.Monitor Accounts")}
                        </Link>
                      </NavDropdown>
                    )}
                  </NavDropdown>
                )}

              </React.Fragment>
            )}
          </Nav>
        </Navbar.Collapse>{" "}
      </Navbar>
      {/* <AnnouncementPreview
        show={showAnnouncements}
        handleClose={handleClose}
        currentCompanySetting={currentCompanySetting}
        announcements={announcements}
      /> */}
    </React.Fragment>
  );
};

export default Navigation;
